import { router } from '@inertiajs/react'
import { TrendsView } from '@/components/trends/TrendsView'
import type { TrendsViewProps } from '@/components/trends/types'

type Props = Omit<TrendsViewProps, 'onStreamChange' | 'onDaysChange'>

function buildUrl(streamId: string | null, days: string) {
  const params = new URLSearchParams()
  if (streamId) params.set('stream', streamId)
  if (days && days !== '30') params.set('days', days)
  const queryString = params.toString()
  return queryString ? `/trends?${queryString}` : '/trends'
}

export default function TrendsIndex(props: Props) {
  const handleStreamChange = (streamId: string | null) => {
    router.visit(buildUrl(streamId, props.selectedDays), {
      preserveScroll: true,
    })
  }

  const handleDaysChange = (days: string) => {
    router.visit(buildUrl(props.selectedStreamId, days), {
      preserveScroll: true,
    })
  }

  return (
    <TrendsView
      {...props}
      onStreamChange={handleStreamChange}
      onDaysChange={handleDaysChange}
    />
  )
}
